import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebaseConfig";

const carTypes = ["SuperCar", "HyperCar", "Truck", "RV", "Sedan", "SUV"];
const locations = ["New York", "Los Angeles", "Chicago", "Houston", "Miami"];
const featuresList = [
  "Air Conditioning", "Leather Seats", "Sunroof", "Bluetooth",
  "Navigation System", "Backup Camera", "Heated Seats", "All Wheel Drive",
  "Cruise Control", "Keyless Entry"
];
const lorem = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

const getRandomFromArray = (arr) => arr[Math.floor(Math.random() * arr.length)];

const generateRandomCar = (name, pictures) => {
  const features = [];
  const featuresCopy = [...featuresList];
  
  for (let i = 0; i < 5; i++) {
    const randomIndex = Math.floor(Math.random() * featuresCopy.length);
    features.push(featuresCopy[randomIndex]);
    featuresCopy.splice(randomIndex, 1);
  }

  const totalValue = Math.floor(Math.random() * (500000 - 5000 + 1)) + 5000;
  const maxPayout = Math.min(totalValue, 100000);
  const price = Math.floor(Math.random() * (maxPayout - 5000 + 1)) + 5000;

  return {
    carName: name,
    pictures: pictures,
    active: true,
    additionalDetails: lorem,
    carType: getRandomFromArray(carTypes),
    isAvailable: true,
    location: getRandomFromArray(locations),
    moneyRaised: Math.floor(Math.random() * 100000),
    totalValue: totalValue,
    price: price,
    private: false,
    features: features,
    createdAt: new Date().toISOString(),
  };
};

const RandomCarGeneratorPage = () => {
  const [carName, setCarName] = useState("");
  const [pictures, setPictures] = useState([]);
  
  const handlePictureChange = (e) => {
    setPictures(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const storage = getStorage();
      const pictureURLs = [];

      for (let file of pictures) {
        const storageRef = ref(storage, `cars/${Date.now()}_${file.name}`);
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        pictureURLs.push(url);
      }

      const newCar = generateRandomCar(carName, pictureURLs);
      const carDocRef = await addDoc(collection(db, "cars"), newCar);

      // Generate a random payout for the new car
      const randomAmount = Math.floor(Math.random() * 20001);
      await addDoc(collection(db, "payouts"), {
        amount: randomAmount,
        carID: carDocRef.id,
        timestamp: new Date(),
      });

      alert(`Car generated with ID: ${carDocRef.id}`);
      setCarName("");
      setPictures([]);
    } catch (err) {
      console.error("Error adding car:", err);
      alert("Error generating car.");
    }
  };

  return (
    <div style={{ maxWidth: "600px", margin: "auto", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>Random Car Generator</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <label>
          Car Name:
          <input 
            type="text" 
            value={carName} 
            onChange={e => setCarName(e.target.value)}
            required 
            style={{ width: "100%", padding: "8px", marginTop: "4px" }}
          />
        </label>
        <label>
          Upload Pictures:
          <input 
            type="file" 
            multiple 
            onChange={handlePictureChange}
            style={{ width: "100%", padding: "8px", marginTop: "4px" }}
          />
        </label>
        <button 
          type="submit" 
          style={{ 
            padding: "10px", 
            backgroundColor: "#007bff", 
            color: "white", 
            border: "none", 
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Generate Car
        </button>
      </form>
    </div>
  );
};

export default RandomCarGeneratorPage;
